import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GamesSliderComponent } from './games-slider.component';
import { DataSliderModule, ProgressModule, SvgIconModule, UtilsModule } from '@mtgame/ui';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ProgressModule,
    DataSliderModule,
    SvgIconModule,
    UtilsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    GamesSliderComponent
  ],
  declarations: [
    GamesSliderComponent,
  ]
})
export class GamesSliderModule {}
